var _defs, _g, _g2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g3, _g4, _path2, _rect12, _path3, _path4, _path5, _rect13, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daf4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c8bf8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7058",
    "data-name": "Groupe 7058",
    transform: "translate(-207.345 -178)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    transform: "translate(207.345 178)",
    stroke: "#eee",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 73,
    rx: 36.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7053",
    "data-name": "Groupe 7053",
    transform: "translate(211.956 198.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9807",
    "data-name": "Trac\\xE9 9807",
    d: "M89.185,262.082a10.006,10.006,0,0,0-4.784-.939,27.807,27.807,0,0,0-5.176.959c-1.245-1.111-5.695-2.092-8.658.024a3.853,3.853,0,0,0-5.783-1.627,5.811,5.811,0,1,0-11.48-1.6,2.753,2.753,0,0,0-3.918-2.446,5.338,5.338,0,0,0-10.641.846,3.852,3.852,0,0,0-4.815-1.557,3.322,3.322,0,0,0-.494.287,3.657,3.657,0,0,0-.957,1c-2.1-.621-5.612-.085-6.573,2.87a4.379,4.379,0,0,0-.207,1.7,3.732,3.732,0,0,0,.107.641,1.609,1.609,0,0,0-1.346.835,2.589,2.589,0,0,0-.169,1.874,3.935,3.935,0,0,0,5.641,2.541,5.43,5.43,0,0,0,4.043,2.557,7.812,7.812,0,0,0,4.757-1.068c-.821,2.294,1.473,4.1,2.423,4.517a7.8,7.8,0,0,0,9.412-2.734,3.074,3.074,0,0,0,2.843,1.142,2.609,2.609,0,0,0,2.072-1.624,5.879,5.879,0,0,0,5.015,1.8,5.141,5.141,0,0,0,4.357-2.615A3.3,3.3,0,0,0,67,269.7c2.4-.732,2.268-2.628,1.978-3.093a1.641,1.641,0,0,0,.868.105,2.449,2.449,0,0,0,1.46-.879l.211.076a8.323,8.323,0,0,0,3.513.47,9.676,9.676,0,0,0,4.624-1.807c1.357-.075,2.612-.151,3.861-.314q.474-.06.95-.142a21.672,21.672,0,0,0,3.831-1c.225-.08.452-.164.681-.254C89.557,262.635,89.565,262.35,89.185,262.082Z",
    transform: "translate(-24.194 -251.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9808",
    "data-name": "Trac\\xE9 9808",
    d: "M283.2,306.923c-.229.091-.456.174-.681.254a21.675,21.675,0,0,1-3.831,1q-.477.082-.95.142c-1.25.163-2.5.24-3.861.314a9.676,9.676,0,0,1-4.624,1.807,8.323,8.323,0,0,1-3.513-.47l-.211-.076a2.448,2.448,0,0,1-1.46.879,3.544,3.544,0,0,1,.151-1.793l.011-.033a2.393,2.393,0,0,1,.569-.9,2.274,2.274,0,0,1,2-.483,4.252,4.252,0,0,1,1.863,1,5.271,5.271,0,0,1,5.14-1.644,4.175,4.175,0,0,0,.937.185,3.182,3.182,0,0,0,.85-.154,21.022,21.022,0,0,1,7.814-.817C283.789,306.411,283.782,306.7,283.2,306.923Z",
    transform: "translate(-218.419 -295.686)",
    fill: "#cce1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9809",
    "data-name": "Trac\\xE9 9809",
    d: "M70,299.105a1.751,1.751,0,0,0-.939.292,4.356,4.356,0,0,0-3.358-.165,2.725,2.725,0,0,1,2.971-1.767,3.764,3.764,0,0,0-4.085.211,5.84,5.84,0,0,0-.747.988,5.025,5.025,0,0,0-2.908-1.94,3.755,3.755,0,0,0-3.485,1.6,4.414,4.414,0,0,0-7.185-1.718c1.567-.547,3.266-.459,3.676,1.161a2.678,2.678,0,0,0-3.651,1.613,1.129,1.129,0,0,0-1.745-.679,1.08,1.08,0,0,0-.294,1.09c-2.492-1.756-6.067-.805-7.146.47.462-1.532,1.98-2.184,3.7-2.11a5.807,5.807,0,0,0-6.63-.592,2.461,2.461,0,0,0-.892-3.465,2.767,2.767,0,0,0-3.5,1.093,3.294,3.294,0,0,0,.467,3.77,8.233,8.233,0,0,0-2.933.446,2.7,2.7,0,0,1,.949,1.836,4.744,4.744,0,0,0-3.668-1.711,2.471,2.471,0,0,1,1.861-.378,4.318,4.318,0,0,0-1.137-1.8,4.6,4.6,0,0,0-3.513-.923,1.609,1.609,0,0,0-1.346.835,2.589,2.589,0,0,0-.169,1.874,3.935,3.935,0,0,0,5.641,2.541,5.43,5.43,0,0,0,4.043,2.557,7.812,7.812,0,0,0,4.757-1.068c-.821,2.294,1.473,4.1,2.423,4.517a7.8,7.8,0,0,0,9.412-2.734,3.074,3.074,0,0,0,2.843,1.142,2.61,2.61,0,0,0,2.072-1.624,5.879,5.879,0,0,0,5.015,1.8,5.141,5.141,0,0,0,4.357-2.615,3.3,3.3,0,0,0,2.149.236c2.4-.732,2.268-2.628,1.978-3.093a1.641,1.641,0,0,0,.868.105,2.448,2.448,0,0,0,1.46-.879l.211.076a8.324,8.324,0,0,0,3.513.47A12.844,12.844,0,0,0,70,299.105Z",
    transform: "translate(-24.194 -285.807)",
    fill: "#cce1f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7052",
    "data-name": "Groupe 7052",
    transform: "translate(228.993 180.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7051",
    "data-name": "Groupe 7051",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7050",
    "data-name": "Groupe 7050",
    transform: "translate(0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9811",
    "data-name": "Trac\\xE9 9811",
    d: "M0,0H10.256l.021,21.513a33.213,33.213,0,0,1-5.634-.794A36.2,36.2,0,0,1-.049,19.3Z",
    transform: "translate(2.668 48.896)",
    fill: "#eeb23b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 14.337,
    height: 16.144,
    transform: "translate(0.628 34.033)",
    fill: "#eeb23b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 14.337,
    height: 2.489,
    transform: "translate(0.628 47.688)",
    fill: "#e6a21b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 8.372,
    height: 10.74,
    transform: "translate(3.61 36.948)",
    fill: "#e6a21b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 10.256,
    height: 2.134,
    transform: "translate(2.668 34.53)",
    fill: "#e6a21b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 0.728,
    height: 1.885,
    transform: "translate(3.636 34.654)",
    fill: "#753806"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 0.729,
    height: 1.885,
    transform: "translate(5.154 34.654)",
    fill: "#753806"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 0.728,
    height: 1.885,
    transform: "translate(6.673 34.654)",
    fill: "#753806"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 0.728,
    height: 1.885,
    transform: "translate(8.191 34.654)",
    fill: "#753806"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 0.728,
    height: 1.885,
    transform: "translate(9.709 34.654)",
    fill: "#753806"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 0.729,
    height: 1.885,
    transform: "translate(11.227 34.654)",
    fill: "#753806"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 14.337,
    height: 1.176,
    transform: "translate(0.628 32.964)",
    fill: "#cc8900"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7048",
    "data-name": "Groupe 7048",
    transform: "translate(3.991 37.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9758",
    "data-name": "Trac\\xE9 9758",
    d: "M42.564,108.549c-.3.037-.6.066-.9.089s-.6.054-.9.075c-.6.042-1.2.073-1.807.1s-1.2.044-1.807.054-1.2.023-1.807.013l-.373-.006v-.367c0-.776.047-1.553.095-2.329s.1-1.553.126-2.329.028-1.553.017-2.329-.059-1.553-.094-2.329l-.01-.215.239-.013c1.2-.069,2.409-.133,3.614-.154l1.807-.037c.6-.011,1.2-.03,1.807-.026l.441,0,0,.443c.008.777-.007,1.553-.021,2.329s-.04,1.553-.072,2.329-.078,1.553-.125,2.329c-.021.388-.046.776-.082,1.165s-.062.776-.1,1.165l0,.037Zm-.046-.088c-.04-.372-.069-.745-.1-1.118-.035-.388-.06-.776-.082-1.165-.047-.777-.1-1.553-.125-2.329s-.056-1.553-.072-2.329-.029-1.553-.022-2.329l.446.446c-.6,0-1.2-.015-1.807-.026l-1.807-.037c-1.2-.021-2.409-.085-3.614-.154l.229-.229c-.035.777-.08,1.553-.094,2.329s-.014,1.553.017,2.329.087,1.553.126,2.329.093,1.553.095,2.329l-.373-.373c.6-.009,1.2.006,1.807.014s1.2.032,1.807.054,1.2.057,1.807.1c.3.021.6.051.9.075C41.946,108.4,42.231,108.426,42.518,108.461Z",
    transform: "translate(-34.963 -98.744)",
    fill: "#ae7500"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7049",
    "data-name": "Groupe 7049",
    transform: "translate(4.611 38.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9759",
    "data-name": "Trac\\xE9 9759",
    d: "M43.082,105.065s0,.084-.009.239a1.982,1.982,0,0,1-.026.287,3.027,3.027,0,0,1-.063.387,3.818,3.818,0,0,1-.347,1.007,3.483,3.483,0,0,1-.871,1.1,2.99,2.99,0,0,1-1.549.655,3.929,3.929,0,0,1-.466.015,3.092,3.092,0,0,1-.454-.062,2.989,2.989,0,0,1-.9-.334,3.794,3.794,0,0,1-1.383-1.369,4.034,4.034,0,0,1-.477-2.95,3.786,3.786,0,0,1,.374-.961,3.523,3.523,0,0,1,1.438-1.4,3.114,3.114,0,0,1,1.859-.323,3.073,3.073,0,0,1,1.56.682,3.545,3.545,0,0,1,.869,1.108,3.807,3.807,0,0,1,.346,1.008,3.047,3.047,0,0,1,.062.387,1.955,1.955,0,0,1,.025.288C43.079,104.981,43.082,105.065,43.082,105.065Zm-.042,0s-.005-.082-.014-.237a1.961,1.961,0,0,0-.032-.283,2.192,2.192,0,0,0-.084-.375,3.354,3.354,0,0,0-1.35-1.852,3.186,3.186,0,0,0-1.383-.528,2.971,2.971,0,0,0-1.63.276,3.172,3.172,0,0,0-1.315,1.2,3.784,3.784,0,0,0-.557,1.8,3.952,3.952,0,0,0,.092.959,3.541,3.541,0,0,0,.362.9,2.962,2.962,0,0,0,1.371,1.234,2.793,2.793,0,0,0,.84.231,3.049,3.049,0,0,0,.431.021,3.673,3.673,0,0,0,.4-.033,3.321,3.321,0,0,0,1.4-.556,3.394,3.394,0,0,0,1.347-1.86,2.2,2.2,0,0,0,.082-.375,1.871,1.871,0,0,0,.031-.283Z",
    transform: "translate(-36.445 -101.324)",
    fill: "#ae7500"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9760",
    "data-name": "Trac\\xE9 9760",
    d: "M43.45,106.293a2.67,2.67,0,1,1-2.669-2.735A2.7,2.7,0,0,1,43.45,106.293Z",
    transform: "translate(-32.803 -63.975)",
    fill: "#b8d0d1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 7.591,
    height: 7.823,
    transform: "translate(4 50.746)",
    fill: "#e6a21b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9761",
    "data-name": "Trac\\xE9 9761",
    d: "M26.925,78.055,30.3,71.939l-.39-.853h9v.853l2.355,6.115Z",
    transform: "translate(-26.297 -45.09)",
    fill: "#5f8e8d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9762",
    "data-name": "Trac\\xE9 9762",
    d: "M29.994,71.124a6.288,6.288,0,0,1-.069,1.209,13.1,13.1,0,0,1-1.012,1.759c-.644,1.259-1.269,2.564-1.838,3.849a4.048,4.048,0,0,1,2.079.015,13.647,13.647,0,0,0,3.7-.157c-.23-.569-1.507-.342-1.575-1.029-.041-.405.533-.594.8-.857A2.861,2.861,0,0,0,33,74.258a2,2,0,0,1,.8-1.679c.356-.374.569-.916.931-1.226-1.29-.066-3.578-.634-4.738-.085Z",
    transform: "translate(-26.385 -45.058)",
    fill: "#3b7572"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9763",
    "data-name": "Trac\\xE9 9763",
    d: "M34.053,71.244c1.746-.672,4.718,1.281,5.981,2.291a6.337,6.337,0,0,1,2.122,4.241,24,24,0,0,1,3.139-.061c-.959-.4-1.783-3.255-2.243-4.317a5.119,5.119,0,0,1-.436-1.088c-.049-.291.137-.7.09-.925-.142-.689-.783-.5-1.392-.5-1.459,0-2.825.141-4.276.071a12.472,12.472,0,0,0-3.465.059c.145-.054.05-.163.131-.273Z",
    transform: "translate(-30.164 -44.893)",
    fill: "#3b7572"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 8.071,
    height: 6.614,
    transform: "translate(4 19.381)",
    fill: "#eeb23b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9764",
    "data-name": "Trac\\xE9 9764",
    d: "M42.707,70.26a.528.528,0,0,1-.523.533H34.1a.528.528,0,0,1-.523-.533h0a.528.528,0,0,1,.523-.534h8.087a.528.528,0,0,1,.523.534Z",
    transform: "translate(-30.164 -44.3)",
    fill: "#5f8e8d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9765",
    "data-name": "Trac\\xE9 9765",
    d: "M36.072,123.834c0-.663-.152-1.2-.338-1.2s-.338.537-.339,1.2Z",
    transform: "translate(-31.223 -75.068)",
    fill: "#753806"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9766",
    "data-name": "Trac\\xE9 9766",
    d: "M39.075,123.834c0-.663-.151-1.2-.338-1.2s-.338.537-.338,1.2Z",
    transform: "translate(-32.97 -75.068)",
    fill: "#753806"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9767",
    "data-name": "Trac\\xE9 9767",
    d: "M42.078,123.834c0-.663-.151-1.2-.339-1.2s-.338.537-.338,1.2Z",
    transform: "translate(-34.717 -75.068)",
    fill: "#753806"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9768",
    "data-name": "Trac\\xE9 9768",
    d: "M45.081,123.834c0-.663-.151-1.2-.338-1.2s-.338.537-.338,1.2Z",
    transform: "translate(-36.463 -75.068)",
    fill: "#753806"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9769",
    "data-name": "Trac\\xE9 9769",
    d: "M47.865,123.834c0-.663-.151-1.2-.338-1.2s-.338.537-.338,1.2Z",
    transform: "translate(-38.082 -75.068)",
    fill: "#753806"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9770",
    "data-name": "Trac\\xE9 9770",
    d: "M50.868,123.834c0-.663-.151-1.2-.338-1.2s-.338.537-.338,1.2Z",
    transform: "translate(-39.828 -75.068)",
    fill: "#753806"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9771",
    "data-name": "Trac\\xE9 9771",
    d: "M44.54,109.868a.245.245,0,1,1-.242-.284A.266.266,0,0,1,44.54,109.868Z",
    transform: "translate(-36.26 -67.479)",
    fill: "#004946"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9772",
    "data-name": "Trac\\xE9 9772",
    d: "M40.986,106.776c-.019-.021,0-.07.042-.11h0c.042-.041.092-.056.111-.035l2.148,2.345c.019.021,0,.07-.042.11h0c-.043.04-.092.056-.111.035Z",
    transform: "translate(-34.47 -65.756)",
    fill: "#004946"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9773",
    "data-name": "Trac\\xE9 9773",
    d: "M46.159,105.134c.033-.024.093.005.136.065h0c.043.06.051.128.018.152l-3.675,2.719c-.032.023-.093-.005-.136-.065h0c-.042-.06-.051-.128-.018-.152Z",
    transform: "translate(-35.335 -64.887)",
    fill: "#004946"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9774",
    "data-name": "Trac\\xE9 9774",
    d: "M46.028,88.176c.263,1.715-.442,3.8-.986,5.388a42.955,42.955,0,0,1-2.714,6.755c-.788,1.432-2.119,4.007-3.548,4.926.486,0,8.323.091,9.08,0-.061-2.061.323-15.23.261-16.482-.064-1.283-1.657-.535-2.354-.64Z",
    transform: "translate(-33.192 -54.927)",
    fill: "#e6a21b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9775",
    "data-name": "Trac\\xE9 9775",
    d: "M44.014,87.712c1.11.1,1.907,2.154,2.345,2.955a23.175,23.175,0,0,1,2.26,5,22.616,22.616,0,0,1,.628,6.372,11.31,11.31,0,0,1-.146,1.693c-.039.21-.231.67-.108.826.255.323,1.787.185,2.181.164a35.778,35.778,0,0,1-.256-4.611c-.058-1.868-.133-3.774-.052-5.642.057-1.313.051-2.636.148-3.946a12.311,12.311,0,0,0,.213-2.481c-2.447.045-5.037-.7-7.47-.285.081-.083.088-.211.153-.31Z",
    transform: "translate(-36.086 -54.604)",
    fill: "#e6a21b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9776",
    "data-name": "Trac\\xE9 9776",
    d: "M28.654,90.8c-.69.054-.775,1.639-.59,2.16.144.407.623.709.649,1.165s-.391.826-.537,1.233a4.491,4.491,0,0,0,.131,2.324c.154,1.006.264,2.039.4,3.04.148,1.083.369,2.165.573,3.232a8.531,8.531,0,0,0,1.023,2.356,11.548,11.548,0,0,0-2.762.11c-.131-5.117.485-10.417-.134-15.467a3.561,3.561,0,0,1,1.124.131c-.126.119-.241.064-.436.071Z",
    transform: "translate(-26.579 -56.556)",
    fill: "#ffc654"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9777",
    "data-name": "Trac\\xE9 9777",
    d: "M37.734,55.241a2.363,2.363,0,0,0-.628,1.811c-.061.676-.372,1.238-.434,1.909a4.477,4.477,0,0,0,.287,2.24,5.315,5.315,0,0,1-2.215-.14c.158-1.665.644-4.164.136-5.805.925-.066,2.156-.195,2.923-.157Z",
    transform: "translate(-30.845 -35.789)",
    fill: "#ffc654"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9778",
    "data-name": "Trac\\xE9 9778",
    d: "M37.868,62.189a.382.382,0,0,1-.378.385h0a.382.382,0,0,1-.378-.385V58.168a.382.382,0,0,1,.378-.385h0a.382.382,0,0,1,.378.385Z",
    transform: "translate(-32.222 -37.354)",
    fill: "#753806"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9779",
    "data-name": "Trac\\xE9 9779",
    d: "M41.494,62.189a.381.381,0,0,1-.377.385h0a.382.382,0,0,1-.378-.385V58.168a.382.382,0,0,1,.378-.385h0a.382.382,0,0,1,.377.385Z",
    transform: "translate(-34.33 -37.354)",
    fill: "#753806"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9780",
    "data-name": "Trac\\xE9 9780",
    d: "M44.848,62.189a.382.382,0,0,1-.378.385h0a.381.381,0,0,1-.378-.385V58.168a.382.382,0,0,1,.378-.385h0a.382.382,0,0,1,.378.385Z",
    transform: "translate(-36.281 -37.354)",
    fill: "#753806"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9781",
    "data-name": "Trac\\xE9 9781",
    d: "M47.916,62.189a.382.382,0,0,1-.378.385h0a.381.381,0,0,1-.378-.385V58.168a.382.382,0,0,1,.378-.385h0a.382.382,0,0,1,.378.385Z",
    transform: "translate(-38.065 -37.354)",
    fill: "#753806"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9782",
    "data-name": "Trac\\xE9 9782",
    d: "M50.706,62.189a.381.381,0,0,1-.378.385h0a.381.381,0,0,1-.377-.385V58.168a.382.382,0,0,1,.377-.385h0a.382.382,0,0,1,.378.385Z",
    transform: "translate(-39.688 -37.354)",
    fill: "#753806"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9783",
    "data-name": "Trac\\xE9 9783",
    d: "M38.054,137.566c0,.284-.169.515-.378.515h0c-.209,0-.378-.231-.378-.515V132.2c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-32.33 -80.331)",
    fill: "#cc8900"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9784",
    "data-name": "Trac\\xE9 9784",
    d: "M41.68,137.566c0,.284-.169.515-.378.515h0c-.208,0-.378-.231-.378-.515V132.2c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-34.439 -80.331)",
    fill: "#cc8900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9785",
    "data-name": "Trac\\xE9 9785",
    d: "M47.538,137.821c0,.284-.169.515-.378.515h0c-.209,0-.378-.231-.378-.515v-5.369c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-37.845 -80.479)",
    fill: "#cc8900"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9786",
    "data-name": "Trac\\xE9 9786",
    d: "M51.164,137.821c0,.284-.169.515-.378.515h0c-.208,0-.378-.231-.378-.515v-5.369c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-39.954 -80.479)",
    fill: "#cc8900"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    d: "M0,0H7.591a0,0,0,0,1,0,0V7.824a0,0,0,0,1,0,0H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z",
    transform: "translate(4.209 61.201)",
    fill: "#e6a21b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9787",
    "data-name": "Trac\\xE9 9787",
    d: "M38.554,162.551c0,.284-.169.514-.378.514h0c-.208,0-.378-.231-.378-.514v-5.369c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-32.621 -94.861)",
    fill: "#cc8900"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9788",
    "data-name": "Trac\\xE9 9788",
    d: "M42.18,162.551c0,.284-.169.514-.378.514h0c-.209,0-.378-.231-.378-.514v-5.369c0-.285.169-.515.378-.515h0c.209,0,.378.23.378.515Z",
    transform: "translate(-34.729 -94.861)",
    fill: "#cc8900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9789",
    "data-name": "Trac\\xE9 9789",
    d: "M48.038,162.806c0,.284-.169.514-.378.514h0c-.209,0-.378-.231-.378-.514v-5.369c0-.285.169-.516.378-.516h0c.209,0,.378.231.378.516Z",
    transform: "translate(-38.136 -95.009)",
    fill: "#cc8900"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9790",
    "data-name": "Trac\\xE9 9790",
    d: "M51.664,162.806c0,.284-.169.514-.378.514h0c-.209,0-.378-.231-.378-.514v-5.369c0-.285.169-.516.378-.516h0c.209,0,.378.231.378.516Z",
    transform: "translate(-40.245 -95.009)",
    fill: "#cc8900"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9791",
    "data-name": "Trac\\xE9 9791",
    d: "M27.107,128.436c-.013.049-.12.01-.06.128,2.033.756,1.52,2.1,1.89,3.975.287-.788-.208-2.714.417-3.31a7.128,7.128,0,0,1,2.476-.509c-1.566.054-3.184-.285-4.731-.208-.078-.062.036-.056.008-.147Z",
    transform: "translate(-26.358 -78.402)",
    fill: "#ae7500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9792",
    "data-name": "Trac\\xE9 9792",
    d: "M56.442,128.479c-1.026.413-1.912,2.159-2.023,3.25a19.255,19.255,0,0,0-.14-2.255c-.123-.93-.477-.7-1.041-1.122,1.12-.1,2.522.2,3.558-.145a2.825,2.825,0,0,1-.564-.013Z",
    transform: "translate(-41.6 -78.303)",
    fill: "#ae7500"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9793",
    "data-name": "Trac\\xE9 9793",
    d: "M45.421,72.717c-.092.478.039,1.075-.208,1.493-.272-.064-.3-.5-.558-.5-.137,0-.48.417-.694.49a7.183,7.183,0,0,1-1.906-.057,17.965,17.965,0,0,1-3.449.142,24.038,24.038,0,0,0,3.95.285,5.563,5.563,0,0,1,1.769-.005c.507.241.245.669.943.3.055.393.311.321.435.49a3.627,3.627,0,0,1,.4.711,4.114,4.114,0,0,1,.636,1.84,12.8,12.8,0,0,1-2.1.295c1.242-.055,2.494.482,3.763.5-1.95-1.726-1.879-4.809-3.184-6.76Z",
    transform: "translate(-33.09 -45.584)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9794",
    "data-name": "Trac\\xE9 9794",
    d: "M34.985,28.343h8.071l-1.614-3.194L39.031,9.215l-.07-.254-.181.573L36.868,24.093Z",
    transform: "translate(-30.985 -8.961)",
    fill: "#3b7572"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9795",
    "data-name": "Trac\\xE9 9795",
    d: "M44.124,15.99c0,.362-.421.657-.941.657s-.941-.295-.941-.657.421-.657.941-.657S44.124,15.628,44.124,15.99Z",
    transform: "translate(-35.205 -12.667)",
    fill: "#3b7572"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9796",
    "data-name": "Trac\\xE9 9796",
    d: "M39.273,10a2.956,2.956,0,0,0-.146,1.536c.028.268.123.525.136.8.023.472-.162.551-.234.984-.066.4.167.573.259.928a7.7,7.7,0,0,1-.172,2.156c-.119,3.158-.411,6.314-.523,9.465a3.387,3.387,0,0,0,0,1.1c.18.319,1.278.482,1.168,1.077-.07.379-.818.433-1.087.483-.925.172-2.291-.194-3.105.3-.039-.5.662-1.3.884-1.758a17.774,17.774,0,0,0,1.025-2.137,19.824,19.824,0,0,0,.452-4.355c.149-1.647.359-3.344.6-4.973a17.7,17.7,0,0,0,.267-2.661c-.3-.036-.184-.2-.139-.424.015-.073.223-.076.255-.168s-.024-.253,0-.359a5.494,5.494,0,0,0,.105-2.311Z",
    transform: "translate(-31.32 -9.382)",
    fill: "#5f8e8d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9797",
    "data-name": "Trac\\xE9 9797",
    d: "M42.707,54.069a.317.317,0,0,1-.314.32H33.888a.317.317,0,0,1-.314-.32h0a.317.317,0,0,1,.314-.321h8.505a.317.317,0,0,1,.314.321Z",
    transform: "translate(-30.164 -35.007)",
    fill: "#005e57"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9798",
    "data-name": "Trac\\xE9 9798",
    d: "M44.516,17.748c-.664.042.04.73.052,1.067.009.252-.158.448-.118.7.03.192.225.481.274.7a8.113,8.113,0,0,1,.054,1.892,22.218,22.218,0,0,0,.314,2.27c.11,1.106.155,2.23.209,3.347.021.443-.021.89,0,1.333a7.606,7.606,0,0,1,.154,1.28c-.01.068.073.2.1.256-.48.033-1.133.011-1.519.011.338-.032,1.727.033,1.88.319.1.192-.167.288-.136.428.057.251.066.131.2.308.082.112.259.034.371.227.01.018-.091.368-.1.418a7.283,7.283,0,0,1,1.872.554c-.4,0-1.171-1.846-1.343-2.306a13.262,13.262,0,0,1-.536-2.869c-.289-2.176-.659-4.366-.943-6.531-.15-1.144-.388-2.281-.53-3.394-.072.031-.225.008-.3.039a.822.822,0,0,1-.008-.208Z",
    transform: "translate(-36.25 -13.978)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9799",
    "data-name": "Trac\\xE9 9799",
    d: "M39.52,18.095a49.611,49.611,0,0,1-.587,8.121,9.09,9.09,0,0,1-.772,2.772c-.212.4-.786,1.237-1.087.474-.445,1.007-1.549,2.088-1.627,3.187a27.569,27.569,0,0,0,7.313-.374c-1.867-1.609-1.8-4.791-2.245-7.087-.3-1.537-.323-3.052-.472-4.6-.081-.842.066-2.225-.458-2.922-.114-.151-.081-.236-.327-.212Z",
    transform: "translate(-31.253 -13.898)",
    fill: "#3b7572",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9800",
    "data-name": "Trac\\xE9 9800",
    d: "M41.526,21.871c-.062,1.016.231,1.992.107,3.037a12.142,12.142,0,0,0-.217,2.342,10.6,10.6,0,0,0,.387,1.326,6.7,6.7,0,0,1-.435,4.016,4.462,4.462,0,0,1-1.3,1.4,5.224,5.224,0,0,1-1.347.784,7.108,7.108,0,0,0,3.333.218,10.773,10.773,0,0,1,2.7.041c-.787-.575-1.075-1.973-1.449-2.831a18.192,18.192,0,0,1-.823-4.08c-.4-2.2-.218-4.836-.9-6.841Z",
    transform: "translate(-33.154 -16.128)",
    fill: "#3b7572",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9801",
    "data-name": "Trac\\xE9 9801",
    d: "M42.121,16.428c-.049-.069.006-.157-.148-.1-.18.4.089.426.151.739a3.179,3.179,0,0,1-.056.867c-.069.773-.2,1.528-.316,2.3a21.216,21.216,0,0,0-.458,4.731A10.519,10.519,0,0,0,42,21.667c.121-.784.154-1.575.272-2.359a6.7,6.7,0,0,0,.263-1.76c-.044-.308-.213-.481-.264-.8-.036-.222.372-.631-.259-.48Z",
    transform: "translate(-34.639 -13.191)",
    fill: "#8bc6c3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9802",
    "data-name": "Trac\\xE9 9802",
    d: "M49.279,55.043a16.51,16.51,0,0,1-.784,4.482,14.581,14.581,0,0,1-1.007,1.64c-.39.664.068.591.312,1.145a4.143,4.143,0,0,1-.09,1.958,7.746,7.746,0,0,1-.59,1.988A9.7,9.7,0,0,0,46.2,68.53a28.993,28.993,0,0,0,3.027.061,10.242,10.242,0,0,1,3.176,0c-.6-.062-.853-1.188-1.068-1.646-.243-.516-.577-.982-.786-1.516-.327-.835-1.085-2.227-.9-3.137.042-.21.295-.3.262-.586-.036-.309-.258-.224-.408-.44-.273-.39-.066-.8-.063-1.281a27.559,27.559,0,0,1,.012-3.571,3.66,3.66,0,0,0,.033-1.474.9.9,0,0,0-.2-.008Z",
    transform: "translate(-37.507 -35.697)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9803",
    "data-name": "Trac\\xE9 9803",
    d: "M40.965,86.37a.449.449,0,0,1-.443.455H25.868a.449.449,0,0,1-.443-.455h0a.449.449,0,0,1,.443-.455H40.522a.45.45,0,0,1,.443.455Z",
    transform: "translate(-25.425 -53.714)",
    fill: "#00443e"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9804",
    "data-name": "Trac\\xE9 9804",
    d: "M30.315,55.449c-.008,1.4.012,2.845-.05,4.254a6.517,6.517,0,0,1-.108,1.506c-.135.363-.59.427-.418.907.056.155.327.23.355.385s-.191.459-.252.628a11.923,11.923,0,0,1-.639,1.334,25.46,25.46,0,0,1-1.624,2.719,6.258,6.258,0,0,1-.764,1.114,6.11,6.11,0,0,1,2.332-.1c-.819.02-.812-.7-.51-1.214a18.51,18.51,0,0,0,.931-2.306,6.181,6.181,0,0,1,.757-1.709c.138-.142.417-.1.5-.264.2-.388-.144-.277-.3-.427-.231-.216-.3,0-.158-.417.083-.251.26-.09.213-.447a6.518,6.518,0,0,1-.212-.629c-.026-.261,0-.536,0-.8V56.892c0-.264,0-.532-.006-.8a.847.847,0,0,0-.256-.008Z",
    transform: "translate(-26.234 -35.997)",
    fill: "#fff",
    opacity: 0.4
  })))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9805",
    "data-name": "Trac\\xE9 9805",
    d: "M31.645,153.581c.141.027.365-.067.575-.052.258.018.412.251.628.265.464.032.719-.514,1.255-.362.249.07.27.3.575.306.338.011.31-.155.574-.261a.746.746,0,0,1,.629-.067c.232.1.249.447.471.529.5.186.774-.616,1.252-.622.451-.006.592.592,1.09.41.451-.165.333-.743.955-.355.285.178.135.4.523.369.2-.016.243-.254.57-.2.241.04.3.2.578.2a2.615,2.615,0,0,0,.56-.157c-.562.042-1.047-.353-1.542-.3-.094.009-.179.244-.285.24-.23-.007-.141-.151-.262-.188-.237-.072-.472-.26-.776-.17-.281.084-.3.339-.626.318-.22-.015-.379-.282-.626-.315-.588-.077-.829.611-1.4.513-.169-.713-.725-.491-1.2-.292-.656.275-.559-.045-1.2-.183-.346-.074-.327.082-.586.171-.433.149-.281.039-.626-.056-.454-.126-1.183-.31-1.1.405,0-.082,0-.164,0-.246Z",
    transform: "translate(-29.039 -92.808)",
    fill: "#e6a21b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9806",
    "data-name": "Trac\\xE9 9806",
    d: "M32.172,150.447c.141.027.365-.067.575-.052.258.018.412.251.628.266.464.031.718-.514,1.255-.362.248.07.27.3.575.306.338.012.309-.155.574-.261a.746.746,0,0,1,.629-.067c.232.1.249.447.471.529.5.186.774-.616,1.252-.622.452-.006.592.593,1.09.411.451-.165.334-.744.955-.356.285.178.135.4.523.369.2-.015.243-.254.57-.2.241.04.3.2.578.2a2.615,2.615,0,0,0,.56-.157c-.562.042-1.047-.353-1.542-.3-.093.009-.179.244-.285.241-.229-.007-.141-.152-.262-.189-.237-.072-.472-.26-.775-.17-.281.084-.3.34-.626.318-.22-.015-.379-.282-.626-.315-.588-.077-.829.611-1.4.513-.169-.713-.725-.491-1.2-.292-.656.275-.559-.045-1.2-.182-.346-.074-.327.082-.586.171-.433.149-.281.04-.626-.056-.454-.126-1.183-.31-1.1.405,0-.082,0-.164,0-.246Z",
    transform: "translate(-29.345 -90.985)",
    fill: "#e6a21b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgThree);
export default __webpack_public_path__ + "static/media/ImgThree.b0fad3918b25a67b3a94db9169a0f143.svg";
export { ForwardRef as ReactComponent };